import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { OrganizationDetailContent } from './OrganizationDetailContent';

// Required for static export with dynamic routes
// Returns empty array to indicate no pre-rendering (client-side routing only)
export async function generateStaticParams() {
    return [];
}

export default function OrganizationDetailPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <OrganizationDetailContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
